import React from 'react';
import ListItem from './listitem';

export default class List extends React.Component {
  getClassName(baseSelector) {
    let className = baseSelector;
    const modifier = this.props.itemClassModifier;
    if (modifier) {
      className += ` ${baseSelector}--${modifier}`;
    }
    return className;
  }

  getClassNames(item) {
    let classNames = [];
    classNames.push(this.getClassName('list__items__item'));

    if (item.visited) {
      classNames.push('port__visited');
    }
    if (item.current) {
      classNames.push('current__port');
    }
    if (item.inTransit) {
      classNames.push('inTransit');
    }
    return classNames;
  }

  renderHeaderItems() {
    return (
      <ListItem
        tag="span"
        className={this.getClassName('list__header__item')}
        items={this.props.headers}
      />
    );
  }

  renderListItems() {
    if (this.props.renderListItems) {
      return this.props.renderListItems();
    }

    const items = this.props.items.map((item, index) => {
      return (
        <ListItem
          key={index}
          tag="li"
          className={this.getClassNames(item).join(' ')}
          items={item}
          headers={this.props.headers}
          onClickItem={this.props.onClickItem}
        />
      );
    });

    // return items;
    return <ul className="list__items">{items}</ul>;
  }

  render() {
    return (
      <div className="list">
        {!this.props.hideHeaders && this.renderHeaderItems()}
        {/* <ul className="list__items">{this.renderListItems()}</ul> */}
        {this.renderListItems()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list.js